export enum DYNAMIC_MODAL_ACTIONS {
  OPEN = 'OPEN',
  CLOSE = 'CLOSE',
  IGNORE = 'IGNORE',
  CANCEL = 'CANCEL',
  CONTINUE = 'CONTINUE',
  REPLACE_PHOTO = 'REPLACE_PHOTO',
  REMOVE_ZOOM = 'REMOVE_ZOOM',
  CHOOSE_FORMAT = 'CHOOSE_FORMAT',
  EXIT = 'EXIT',
  HIDE_MODAL = 'HIDE_MODAL',
  REVIEW = 'REVIEW',
}

export enum DYNAMIC_MODAL_VIEWS {
  QualityAlert = 'QualityAlert',
  MultiplePurchase = 'MultiplePurchase',
  DeleteProduct = 'DeleteProduct',
  EmptyImages = 'EmptyImages',
  UploadToCart = 'UploadToCart',
  ErrorCart = 'ErrorCart',
  SaveChanges = 'SaveChanges',
  ApplyAll = 'ApplyAll',
  ModalUpSelling = 'ModalUpSelling',
  UploadMultiSource = 'UploadMultiSource',
  PrivacyPolicy = 'PrivacyPolicy',
  CutAlert = 'CutAlert',
  CutConfirmationAlert = 'CutConfirmationAlert',
  ConfigurationSteps = 'ConfigurationSteps',
  ConfigurationStepsMobile = 'ConfigurationStepsMobile',
  EditProducts = 'EditProducts',
  AdjustCrops = 'AdjustCrops',
  ExitProject = 'ExitProject',
  DeleteAll = 'DeleteAll',
  PhotoDrawerOrder = 'PhotoDrawerOrder',
  DeleteFromDrawer = 'DeleteFromDrawer',
  OverLimitProducts = 'OverLimitProducts',
  MaxProductsAlert = 'MaxProductAlert',
  MinProductsAlert = 'MinProductAlert',
  UnderMinLimitProducts = 'UnderMinLimitProducts',
  ModalUploadError = 'ModalUploadError',
  ModalNetwork = 'ModalNetwork',
  NoAvailableSpace = 'NoAvailableSpace',
  NewVersionAvailable = 'NewVersionAvailable',
  ProductNotAvailable = 'ProductNotAvailable',
}

export enum MODAL_QUALITY_OPEN_POINTS {
  photo = 'photo',
  banner = 'banner',
  cart_add = 'cart_add',
}

export enum SELECTED_MENU_ITEMS {
  Computer = 'computer',
  GooglePhoto = 'google-photo',
  Gallery = 'gallery',
  Smartphone = 'smartphone',
  FamilyFriends = 'family-friends',
  Add = 'add',
}
